import { render, staticRenderFns } from "./ItemSueldos.vue?vue&type=template&id=65e2506a&"
import script from "./ItemSueldos.vue?vue&type=script&lang=js&"
export * from "./ItemSueldos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports